import "../../NewLP.css";
import React, { useState, useEffect, useRef } from "react";
import $ from "jquery";

// Import Swiper React components and styles
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

// Import all your images
import computerImg from "../../Images/newLP/computer.png";
import isbmLogo from "../../Images/newLP/isbmuniversitylogocolor.png";
import banner from "../../Images/newLP/banner.mp4";
import fee from "../../Images/newLP/fee.png";
import team from "../../Images/newLP/team.png";
import document from "../../Images/newLP/document.png";
import brochurePdf from "../../Images/newLP/BROCHURE.pdf";
import rec1 from "../../Images/newLP/rec/1.png";
import rec2 from "../../Images/newLP/rec/2.png";
import rec3 from "../../Images/newLP/rec/3.png";
import rec4 from "../../Images/newLP/rec/4.png";
import rec5 from "../../Images/newLP/rec/5.png";

// Import course images
import course1 from "../../Images/newLP/course/1.jpg";
import course2 from "../../Images/newLP/course/2.jpg";
import course3 from "../../Images/newLP/course/3.jpg";
import course4 from "../../Images/newLP/course/4.jpg";
import course5 from "../../Images/newLP/course/5.jpg";
import course6 from "../../Images/newLP/course/6.jpg";
import course7 from "../../Images/newLP/course/7.jpg";
import course8 from "../../Images/newLP/course/8.jpg";
import course9 from "../../Images/newLP/course/9.jpg";
import course10 from "../../Images/newLP/course/10.jpg";
import course11 from "../../Images/newLP/course/11.jpg";
import course12 from "../../Images/newLP/course/12.jpg";
import course13 from "../../Images/newLP/course/13.jpg";
import course14 from "../../Images/newLP/course/14.jpg";
import course15 from "../../Images/newLP/course/15.jpg";
import course16 from "../../Images/newLP/course/16.jpg";
import course17 from "../../Images/newLP/course/17.jpg";
import course18 from "../../Images/newLP/course/18.jpg";
import course19 from "../../Images/newLP/course/19.jpg";
import course20 from "../../Images/newLP/course/20.jpg";
import course21 from "../../Images/newLP/course/21.jpg";
import course22 from "../../Images/newLP/course/22.jpg";
import course23 from "../../Images/newLP/course/23.jpg";
import course24 from "../../Images/newLP/course/24.jpg";
import course25 from "../../Images/newLP/course/25.jpg";
import course26 from "../../Images/newLP/course/26.jpg";
import course27 from "../../Images/newLP/course/27.jpg";
import course28 from "../../Images/newLP/course/28.jpg";
import course29 from "../../Images/newLP/course/29.jpg";
import course30 from "../../Images/newLP/course/30.jpg";
import course31 from "../../Images/newLP/course/31.jpg";
import course32 from "../../Images/newLP/course/32.jpg";
import course33 from "../../Images/newLP/course/33.jpg";
import course34 from "../../Images/newLP/course/34.jpg";
import course35 from "../../Images/newLP/course/35.jpg";
import course36 from "../../Images/newLP/course/36.jpg";
import course37 from "../../Images/newLP/course/37.jpg";

import alumni1 from "../../Images/newLP/alumni/New1.png";
import alumni2 from "../../Images/newLP/alumni/New2.jpg";
import alumni3 from "../../Images/newLP/alumni/New3.jpg";
import alumni4 from "../../Images/newLP/alumni/New4.jpg";
import alumni5 from "../../Images/newLP/alumni/New5.jpg";
import alumni6 from "../../Images/newLP/alumni/New6.jpg";
import alumni7 from "../../Images/newLP/alumni/New7.jpg";
import alumni8 from "../../Images/newLP/alumni/New8.jpg";
import alumni9 from "../../Images/newLP/alumni/New9.jpg";
import alumni10 from "../../Images/newLP/alumni/New10.jpg";
import alumni11 from "../../Images/newLP/alumni/New11.jpg";
import alumni12 from "../../Images/newLP/alumni/New12.jpg";
import alumni13 from "../../Images/newLP/alumni/New13.jpg";
import alumni14 from "../../Images/newLP/alumni/New14.jpg";
import alumni15 from "../../Images/newLP/alumni/New15.jpg";
import alumni16 from "../../Images/newLP/alumni/New16.jpg";
import alumni17 from "../../Images/newLP/alumni/New17.jpg";
import LPEnquireForm from "../LP/LPEnquireForm";

function LP({ show, onHide }) {
  const [activeTab, setActiveTab] = useState("PHD");

  const handleClick = (tabId) => {
    setActiveTab(tabId);
  };

  // Create arrays for the carousel data
  const schoolCarouselData = [
    {
      title: "School of Management",
      items: [
        "Doctor of Philosophy (Ph.D.) in Management",
        "Master of Business Administration (MBA)",
        "Executive Master of Business Administration (EMBA)",
        "Bachelor of Business Administration (BBA)",
        "Post Graduate Diploma in Business Administration (PGDBA)",
        "Diploma in Business Administration (DBA)"
      ]
    },
    {
      title: "School of Science",
      items: [
        "Doctor of Philosophy (Ph.D.) in Science",
        "Master of Science (M.Sc.)",
        "M.Sc. in Stem Cells and Tissue Culture Engineering (M.Sc. SCTCE)",
        "M.Sc. in Fire & Safety (M.Sc. F&S)",
        "M.Sc. in Forensic Science & Criminology (M.Sc. FSC)",
        "Bachelor of Science (Hons)",
        "Bachelor of Science (B.Sc.)",
        "B.Sc. in Forensic Science & Criminology (B.Sc. FSC)",
        "B.Sc. in Fire & Safety",
        "Post Graduate Diploma in Science (PGDSC)",
        "Diploma in Nutrition (DIN)",
        "Diploma in Science",
        "Diploma in Forensic Science & Criminology"
      ]
    },
    {
      title: "School of Commerce",
      items: [
        "Doctor of Philosophy (Ph.D.) in Commerce",
        "Master of Commerce (M.Com)",
        "B.Com in Computer Application",
        "Bachelor of Commerce (Hons)",
        "Bachelor of Commerce (B.Com)",
        "Post Graduate Diploma in Commerce (PGDCOM)",
        "Diploma in Commerce"
      ]
    },
    {
      title: "School of Arts and Humanities",
      items: [
        "Doctor of Philosophy (Ph.D.) in Arts and Humanities",
        "Master of Arts (M.A)",
        "Master of Social Work (MSW)",
        "Bachelor of Arts (Hons)",
        "Bachelor of Arts (B.A)",
        "Bachelor of Social Work (BSW)",
        "Post Graduate Diploma in Rural Development"
      ]
    },
    {
      title: "School of Engineering and Technology",
      items: [
        "Doctor of Philosophy (Ph.D.) in Engineering and Technology",
        "Master of Technology (M.Tech)",
        "Bachelor of Technology (B.Tech)",
        "Bachelor of Technology (B.Tech) (Lateral Entry)",
        "Diploma in Engineering",
        "Diploma in Engineering (Lateral Entry)",
        "Post Graduate Diploma in Rural Development"
      ]
    },
    {
      title: "School of Information and Technology",
      items: [
        "Doctor of Philosophy (Ph.D.) in Information Technology",
        "M.Sc. in Information Technology (M.Sc IT)",
        "M.Sc. in Computer Science (M.Sc. CS)",
        "Master of Computer Applications (MCA)",
        "M.Sc. in Data Science",
        "B.Sc. (Hons) in Information Technology",
        "B.Sc. (Hons) in Computer Science",
        "Bachelor of Computer Applications (BCA)",
        "B.Sc. in Data Science",
        "Post Graduate Diploma in Computer Application (PGDCA)",
        "Post Graduate Diploma in Data Science",
        "Post Graduate Diploma in AI & ML",
        "Diploma in Computer Application (DCA)",
        "Diploma in AI & ML"
      ]
    },
    {
      title: "School of Design",
      items: [
        "B.Sc. (Hons) in Fashion Designing",
        "B.Sc. (Hons) in Interior Design",
        "Diploma in Fashion Designing (DFD)",
        "Diploma in Interior Design (DID)",
        "Diploma in Product Design",
        "Diploma in Jewellery Design",
        "Certificate in Fashion Designing (CFD)",
        "Certificate in Interior Design (CID)"
      ]
    },
    {
      title: "School of Pharmacy",
      items: [
        "Doctor of Philosophy (Ph.D.) in Pharmacy",
        "Master of Pharmacy (M Pharma)",
        "Bachelor of Pharmacy (B Pharma)",
        "Diploma in Pharmacy (D Pharma)"
      ]
    },
    {
      title: "School of Life Science",
      items: [
        "Doctor of Philosophy (Ph.D.) in Life Science",
        "M.Sc. in Bio Technology",
        "M.Sc. in Microbiology",
        "B.Sc. (Hons) in Bio Technology",
        "B.Sc. (Hons) in Microbiology"
      ]
    },
    {
      title: "School of Yoga and Naturopathy",
      items: [
        "Doctor of Philosophy (Ph.D.) in Yoga Science and Naturopathy",
        "M.Sc. in Yoga Science and Naturopathy",
        "M.A. in Yoga",
        "B.Sc. (Hons) in Yoga Science and Naturopathy",
        "B.A. (Hons) in Yoga",
        "Post Graduate Diploma in Yoga and Naturopathy",
        "Diploma in Yoga (DIY)",
        "Diploma in Naturopathy (DN)"
      ]
    },
    {
      title: "School of Law",
      items: [
        "Doctor of Philosophy (Ph.D.) in Law",
        "Master of Law (LLM)",
        "Bachelor of Law (LLB)",
        "Bachelor of Business Administration and Bachelor of Law (BBA LLB)",
        "Bachelor of Arts and Bachelor of Law (BA LLB)",
        "Post Graduate Diploma in Law",
        "Diploma in Law"
      ]
    },
    {
      title: "School of Library and Information Science",
      items: [
        "Doctor of Philosophy (Ph.D.) in Library and Information Science",
        "Master of Library and Information Science (M.Lib. & I.Sc.)",
        "Bachelor of Library and Information Science (B.Lib. & I.Sc.)"
      ]
    },
    {
      title: "School of Journalism and Mass Communication",
      items: [
        "Doctor of Philosophy (Ph.D.) in Journalism and Mass Communication",
        "Master of Arts in Journalism and Mass Communication (MA JMC)",
        "Bachelor of Arts (Hons) in Journalism and Mass Communication (BA JMC)",
        "Diploma in Journalism and Mass Communication (D JMC)"
      ]
    },
    {
      title: "School of Education",
      items: [
        "Doctor of Philosophy (Ph.D.) in Education",
        "Master of Arts in Education",
        "Bachelor of Arts (Hons) in Education"
      ]
    },
    {
      title: "School of Hotel Management",
      items: [
        "Doctor of Philosophy (Ph.D.) in Hotel Management and Catering Technology",
        "Master of Hotel Management and Catering Technology (Proposed)",
        "Bachelor of Hotel Management and Catering Technology (BHMCT)",
        "Diploma in Hotel Management and Catering Technology (DHMCT)",
        "Diploma in Culinary Arts",
        "Diploma in Travel & Tourism"
      ]
    },
    {
      title: "School of Health and Allied Science",
      items: [
        "M.Sc. in Medical Biotechnology (M.Sc. MBT)",
        "Bachelor of Physiotherapy",
        "B.Sc. (Hons) in Forensic Science",
        "B.Sc. (Hons) in Nutrition & Dietetics",
        "B.A. (Hons) in Public Health",
        "Post Graduate Diploma in Nutrition and Dietetics",
        "Diploma in Dietetics",
        "Diploma in Nutrition"
      ]
    },
    {
      title: "School of Vocational Studies",
      items: [
        "Bachelor of Vocational Studies",
        "Diploma in Vocational Studies",
        "Certificate in Vocational Studies"
      ]
    },
    {
      title: "School of Media and Entertainment",
      items: [
        "Doctor of Philosophy (Ph.D.) in Media and Entertainment",
        "M.A. in Film Making and Advertising",
        "M.A. in Public Relation and Event Management",
        "B.A. (Hons) in Film Making and Advertising",
        "B.A. (Hons) in Public Relation and Event Management",
        "Diploma in Photography",
        "Diploma in Script Writing",
        "Diploma in Advertising",
        "Diploma in Branding",
        "Diploma in VFX and Animation"
      ]
    }
  ];

  const recData = [
    { img: rec1, text: "UGC" },
    { img: rec2, text: "PCI" },
    { img: rec3, text: "BCI" },
    { img: rec4, text: "AICTE" },
    { img: rec5, text: "AIU" }
  ];

  const phdCourses = [
    { img: course11, title: "Ph.D. Program (Management)" },
    { img: course4, title: "Ph.D. Program (Science)" },
    { img: course2, title: "Ph.D. Program (Commerce)" },
    { img: course3, title: "Ph.D. Program (Arts & Humanities)" },
    { img: course13, title: "Ph.D. Program (Engineering & Technology)" },
    { img: course10, title: "Ph.D. Program (Information & Technology)" },
    { img: course7, title: "Ph.D. Program (Pharmacy)" },
    { img: course33, title: "Ph.D. Program (Life Science)" },
    { img: course4, title: "Ph.D. Program (Yoga & Naturopathy)" },
    { img: course14, title: "Ph.D. Program (Law)" },
    { img: course24, title: "Ph.D. Program (Library & Information Science)" },
    { img: course34, title: "Ph.D. Program (Journalism & Mass Communication)" },
    { img: course5, title: "Ph.D. Program (Education)" },
    { img: course15, title: "Ph.D. Program (Hotel Management)" },
    { img: course25, title: "Ph.D. Program (Media & Entertainment)" }
  ];

  const mastersCourses = [
    { img: course1, title: "Master of Law (LLM)" },
    { img: course2, title: "Master of Arts In Journalism & Mass Communication (MAJMC)" },
    { img: course3, title: "Master of Arts In Comparative Religion & Philosophy (MA)" },
    { img: course4, title: "Master of Arts In Defence Studies (M.A)" },
    { img: course5, title: "Master of Arts In Economics (M.A)" },
    { img: course6, title: "Master of Arts In Education (M.A)" },
    { img: course7, title: "Master of Arts In English (M.A)" },
    { img: course8, title: "Master of Arts In Geography (M.A)" },
    { img: course9, title: "Master of Arts In Hindi (M.A)" },
    { img: course10, title: "Master of Arts In History (M.A)" },
    { img: course11, title: "Master of Arts In Home Science [M.A]" },
    { img: course12, title: "Master of Arts In Marathi(M.A)" },
    { img: course13, title: "Master of Arts In Political Science(M.A)" },
    { img: course14, title: "Master of Arts In Psychology (M.A)" },
    { img: course15, title: "Master of Arts In Public Administration (M.A)" },
    { img: course16, title: "Master of Arts In Sanskrit (M.A)" },
    { img: course17, title: "Master of Arts In Sociology (M.A)" },
    { img: course18, title: "Masters in Business Administration (MBA)" },
    { img: course19, title: "Master of Computer Applications (MCA)" },
    { img: course20, title: "Master of Commerce (M. Com)" },
    { img: course21, title: "Master of Library & Information Science (M. Lib.)" },
    { img: course22, title: "Master of Pharmacy (M-Pharm)" },
    { img: course23, title: "Master of Science in Electronics (MSc-Electronics)" },
    { img: course24, title: "Master of Science in Information Technology (MSc-IT)" },
    { img: course25, title: "Master of Science (MSc)" },
    { img: course26, title: "Master of Science In Bio Chemistry (MSc)" },
    { img: course27, title: "Master of Science In Biology (MSc)" },
    { img: course28, title: "Master of Science In Biotechnology (MSc)" },
    { img: course29, title: "Master of Science In Botany (MSc)" },
    { img: course30, title: "Master of Science in Micro Biology (MSc)" },
    { img: course31, title: "Master of Science In Chemistry (MSc)" },
    { img: course32, title: "Master of Science In Computer Science (MSc)" },
    { img: course33, title: "Master of Science In Mathematics (MSc)" },
    { img: course34, title: "Master of Science In Physics (MSc)" },
    { img: course35, title: "Master of Science In Zoology (MSc)" },
    { img: course36, title: "Master of Social Work (MSW)" },
    { img: course37, title: "Master of Philosophy (M.Phil)" }
  ];

  const bachelorsCourses = [
    { img: course10, title: "Bachelor of Arts (BA)" },
    { img: course20, title: "Bachelors in Business Administration (BBA)" },
    { img: course30, title: "Bachelor of Arts In Journalism & Mass Communication (BA-JMC)" },
    { img: course29, title: "Bachelors in Business Administration & Bachelors of Law (BBA-LLB)" },
    { img: course19, title: "Bachelor of Computer Applications (BCA)" },
    { img: course9, title: "Bachelor of Commerce (B.Com)" },
    { img: course28, title: "Bachelor of Library & Information Science (B.Lib.)" },
    { img: course18, title: "Bachelor of Pharmacy (B-Pharma)" },
    { img: course8, title: "Bachelor of Science (B.Sc.)" },
    { img: course27, title: "Bachelor of Science in Biotechnology (B.Sc.-Biotechnology)" },
    { img: course17, title: "Bachelor of Science in Microbiology (B.Sc.-Microbiology)" },
    { img: course7, title: "Bachelor of Science in Computer Science (B.Sc.CS)" },
    { img: course26, title: "Bachelor of Science in Fashion Designing (B.Sc.FD)" },
    { img: course16, title: "Bachelor of Science in Interior Designing (B.Sc.ID)" },
    { img: course6, title: "Bachelor of Science in Information technology (B.Sc.IT)" },
    { img: course25, title: "Bachelor of Social Work (BSW)" },
    { img: course15, title: "Bachelor of Technology (B-Tech)" },
    { img: course5, title: "Bachelor of Arts Public Administration (BA)" }
  ];

  const diplomaCourses = [
    { img: course2, title: "Diploma in Business Administration (DBA)" },
    { img: course12, title: "Diploma in Nutrition (DIN)" },
    { img: course22, title: "Diploma in Engineering (DE)" },
    { img: course32, title: "Diploma in Journalism and Mass Communication (D-JMC)" },
    { img: course3, title: "Diploma in Interior Design (DID)" },
    { img: course13, title: "Diploma in Computer Application (DCA)" },
    { img: course23, title: "Diploma in Pharmacy [D.Pharm]" },
    { img: course33, title: "Diploma in Yoga (DIY)" },
    { img: course4, title: "Diploma in Naturopathy (DN)" },
    { img: course14, title: "Diploma in Education" },
    { img: course24, title: "Diploma in Hotel Management and Catering Technology (DHMCT)" },
    { img: course34, title: "Post Graduate Diploma in Business Administration (PGDBA)" },
    { img: course5, title: "Post Graduate Diploma in Computer Applications (PGDCA)" },
    { img: course15, title: "Post Graduate Diploma in Naturopathy (PGD)" },
    { img: course25, title: "Post Graduate Diploma in Rural Development (PGD)" },
    { img: course35, title: "Doctor of Philosophy (PHD)" },
    { img: course6, title: "Post Graduate Diploma in Yoga Science and Naturopathy (PGDYSN)" },
    { img: course16, title: "Post Graduate Diploma in Nutrition and Dietetics (PGDND)" }
  ];

  const alumniData = [
    alumni1, alumni2, alumni3, alumni4, alumni5,
    alumni6, alumni7, alumni8, alumni9, alumni10,
    alumni11, alumni12, alumni13, alumni14, alumni15,
    alumni16, alumni17
  ];

  return (
    <div>
      <nav id="navbar_top" className="navbar navbar-expand-lg navbar-dark">
        <div className="container">
          <a href="/" className="navbar-brand d-flex align-items-center">
            <img
              src={isbmLogo}
              className="logo logo-white py-2"
              alt="Logo"
              style={{ height: "80px " }}
              id="mainlogo"
            />
          </a>
        </div>
        {/* container-fluid.// */}
      </nav>

      <section id="home">
        <div className="bannerHome">
          <video autoPlay muted loop>
            <source src={banner} type="video/mp4" />
          </video>
        </div>
      </section>

      <section id="sliderForm">
        <div className="sliderForm">
          <div className="container py-5">
            <div className="row">
              <div className="bannerText col-xl-9 col-lg-8 col-md-6 col-sm-12">
                <h1>Boost your Career with UGC approved programmes</h1>
                <div className="slider-nav">
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={10}
                    slidesPerView={1}
                    navigation={{
                      nextEl: '.custom-next-arrow',
                      prevEl: '.custom-prev-arrow',
                    }}
                    autoplay={{
                      delay: 2000,
                      disableOnInteraction: false,
                    }}
                    breakpoints={{
                      450: {
                        slidesPerView: 2,
                      },
                      1000: {
                        slidesPerView: 3,
                      },
                      1400: {
                        slidesPerView: 4,
                      },
                    }}
                  >
                    {schoolCarouselData.map((school, index) => (
                      <SwiperSlide key={index}>
                        <div className="slider-col mx-1">
                          <div className="headerGradientBtn">
                            <div className="headerGradient">
                              <h5 className="text-gradient">{school.title}</h5>
                            </div>
                            <ul>
                              {school.items.map((item, i) => (
                                <li key={i}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                    <div className="custom-nav">
                      <span className="custom-prev-arrow">
                        <i className="fa-solid fa-angles-left"></i>
                      </span>
                      <span className="custom-next-arrow">
                        <i className="fa-solid fa-angles-right"></i>
                      </span>
                    </div>
                  </Swiper>
                </div>

                <div className="Bannercol">
                  <div className="bannerow mb-4">
                    <div className="featurerow">
                      <img
                        src={fee}
                        className="logo logo-white"
                        alt="Logo"
                        style={{ height: "40px " }}
                        id="mainlogo"
                      />
                      <div className="feature">Affordable Fees</div>
                    </div>
                    <div className="featurerow">
                      <img
                        src={team}
                        className="logo logo-white"
                        alt="Logo"
                        style={{ height: "40px " }}
                        id="mainlogo"
                      />
                      <div className="feature">Job Oriented Programs</div>
                    </div>
                  </div>
                  <div className="bannerow mb-4">
                    <div className="featurerow">
                      <img
                        src={document}
                        className="logo logo-white"
                        alt="Logo"
                        style={{ height: "40px " }}
                        id="mainlogo"
                      />
                      <div className="feature">Best Placements</div>
                    </div>
                    <div className="featurerow">
                      <img
                        src={computerImg}
                        className="logo logo-white"
                        alt="Logo"
                        style={{ height: "40px" }}
                        id="mainlogo"
                      />
                      <div className="feature">Digital Learning Resources</div>
                    </div>
                  </div>
                </div>
                <a
                  href={brochurePdf}
                  className="headerGradientBtn smallText whiteColor"
                  style={{ color: "#FFF" }}
                  download
                >
                  DOWNLOAD BROCHURE
                </a>
              </div>
              <LPEnquireForm />
            </div>
          </div>
        </div>
      </section>

      {/* RECOGNITIONS & APPROVALS Start */}
      <section id="rec">
        <div className="container py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="text-center">
            <h6 className="section-title-lp bg-white text-center text-purple px-3">
              Trust the experts
            </h6>
            <h1 className="mb-5">We're Recognised and Accredited</h1>
          </div>
          <div className="testimonial-carousel position-relative">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              autoplay={{
                delay: 1000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                770: {
                  slidesPerView: 3,
                },
                1000: {
                  slidesPerView: 5,
                },
              }}
            >
              {recData.map((rec, index) => (
                <SwiperSlide key={index}>
                  <div className="testimonial-item text-center">
                    <div className="position-relative overflow-hidden row">
                      <img className="img-fluid2" src={rec.img} alt="" />
                      <h3 className="text-gradient">{rec.text}</h3>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
      {/* RECOGNITIONS & APPROVALS End */}

      {/* Statistics Start */}
      <section id="statistics">
        <div className="container py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="text-center">
            <h6 className="section-title-lp bg-white text-center text-purple px-3">
              Data-driven insights for informed decision-making
            </h6>
            <h1 className="mb-5">Learn from the Leader</h1>
          </div>
          <div className="layout" id="counter">
            <div className="line-item">
              <div className="value">
                <h2 className="fs-38 primaryColor fontBold">
                  <span
                    className="counter-value fs-38 primaryColor fontBold"
                    data-count="18"
                  >
                    18
                  </span>
                  +
                </h2>
              </div>
              <div className="title">Schools</div>
            </div>
            <div className="line-item">
              <div className="value">
                <h2 className="fs-38 primaryColor fontBold">
                  <span
                    className="counter-value fs-38 primaryColor fontBold"
                    data-count="200"
                  >
                    200
                  </span>
                  +
                </h2>
              </div>
              <div className="title">Expert faculty</div>
            </div>
            <div className="line-item">
              <div className="value">
                <h2 className="fs-38 primaryColor fontBold">
                  <span
                    className="counter-value fs-38 primaryColor fontBold"
                    data-count="30"
                  >
                    30
                  </span>
                  +
                </h2>
              </div>
              <div className="title">Awards of Excellence</div>
            </div>
            <div className="line-item">
              <div className="value">
                <h2 className="fs-38 primaryColor fontBold">
                  <span
                    className="counter-value fs-38 primaryColor fontBold"
                    data-count="5000"
                  >
                    5000
                  </span>
                  +
                </h2>
              </div>
              <div className="title">Applicants</div>
            </div>
            <div className="line-item">
              <div className="value">
                <h2 className="fs-38 primaryColor fontBold">
                  <span
                    className="counter-value fs-38 primaryColor fontBold"
                    data-count="100"
                  >
                    100
                  </span>
                  +
                </h2>
              </div>
              <div className="title">Recruiters</div>
            </div>
          </div>
        </div>
      </section>
      {/* Statistics End */}

      {/* Programmes Start */}
      <section id="programmes">
        <div className="container py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="text-center">
            <h6 className="section-title-lp bg-white text-center text-purple px-3">
              Preparing you for the challenges of tomorrow
            </h6>
            <h1 className="mb-5">Our Future-ready Programmes</h1>
          </div>
          <div>
            <div className="tab">
              <button
                className={`tablinks ${activeTab === "PHD" ? "active" : ""}`}
                onClick={() => handleClick("PHD")}
                id="defaultOpen"
              >
                Ph.D.
              </button>
              <button
                className={`tablinks ${activeTab === "Masters" ? "active" : ""
                  }`}
                onClick={() => handleClick("Masters")}
              >
                Masters
              </button>
              <button
                className={`tablinks ${activeTab === "Bachelors" ? "active" : ""
                  }`}
                onClick={() => handleClick("Bachelors")}
              >
                Bachelors
              </button>
              <button
                className={`tablinks ${activeTab === "Diploma" ? "active" : ""
                  }`}
                onClick={() => handleClick("Diploma")}
              >
                Diploma
              </button>
            </div>

            <div
              id="PHD"
              className="tabcontent"
              style={{ display: activeTab === "PHD" ? "block" : "none" }}
            >
              <div className="phd-carousel position-relative">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={20}
                  slidesPerView={1}
                  autoplay={{
                    delay: 1000,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    770: {
                      slidesPerView: 3,
                    },
                  }}
                >
                  {phdCourses.map((course, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial-item text-center mx-3">
                        <div className="position-relative overflow-hidden">
                          <img
                            className="img-fluid1"
                            src={course.img}
                            loading="lazy"
                            alt=""
                          />
                          <div className="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                            <a
                              href="#sliderForm"
                              className="flex-shrink-0 btn btn-sm btn-gradient px-3 border-end"
                              style={{
                                borderRadius: "30px",
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              Apply Now
                            </a>
                          </div>
                        </div>
                        <div className="testimonial-text bg-light text-center p-4">
                          <p className="mb-0">{course.title}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>

            <div
              id="Masters"
              className="tabcontent"
              style={{ display: activeTab === "Masters" ? "block" : "none" }}
            >
              <div className="phd-carousel position-relative">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={20}
                  slidesPerView={1}
                  autoplay={{
                    delay: 1000,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    770: {
                      slidesPerView: 3,
                    },
                  }}
                >
                  {mastersCourses.map((course, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial-item text-center mx-3">
                        <div className="position-relative overflow-hidden">
                          <img
                            className="img-fluid1"
                            src={course.img}
                            loading="lazy"
                            alt=""
                          />
                          <div className="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                            <a
                              href="#sliderForm"
                              className="flex-shrink-0 btn btn-sm btn-gradient px-3 border-end"
                              style={{
                                borderRadius: "30px",
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              Apply Now
                            </a>
                          </div>
                        </div>
                        <div className="testimonial-text bg-light text-center p-4">
                          <p className="mb-0">{course.title}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>

            <div
              id="Bachelors"
              className="tabcontent"
              style={{ display: activeTab === "Bachelors" ? "block" : "none" }}
            >
              <div className="phd-carousel position-relative">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={20}
                  slidesPerView={1}
                  autoplay={{
                    delay: 1000,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    770: {
                      slidesPerView: 3,
                    },
                  }}
                >
                  {bachelorsCourses.map((course, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial-item text-center mx-3">
                        <div className="position-relative overflow-hidden">
                          <img
                            className="img-fluid1"
                            src={course.img}
                            loading="lazy"
                            alt=""
                          />
                          <div className="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                            <a
                              href="#sliderForm"
                              className="flex-shrink-0 btn btn-sm btn-gradient px-3 border-end"
                              style={{
                                borderRadius: "30px",
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              Apply Now
                            </a>
                          </div>
                        </div>
                        <div className="testimonial-text bg-light text-center p-4">
                          <p className="mb-0">{course.title}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>

            <div
              id="Diploma"
              className="tabcontent"
              style={{ display: activeTab === "Diploma" ? "block" : "none" }}
            >
              <div className="phd-carousel position-relative">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={20}
                  slidesPerView={1}
                  autoplay={{
                    delay: 1000,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    770: {
                      slidesPerView: 3,
                    },
                  }}
                >
                  {diplomaCourses.map((course, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial-item text-center mx-3">
                        <div className="position-relative overflow-hidden">
                          <img
                            className="img-fluid1"
                            src={course.img}
                            loading="lazy"
                            alt=""
                          />
                          <div className="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                            <a
                              href="#sliderForm"
                              className="flex-shrink-0 btn btn-sm btn-gradient px-3 border-end"
                              style={{
                                borderRadius: "30px",
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              Apply Now
                            </a>
                          </div>
                        </div>
                        <div className="testimonial-text bg-light text-center p-4">
                          <p className="mb-0">{course.title}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Programmes End */}

      {/* EXCELLENCE Start */}
      <section id="excellence">
        <div className="container py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="text-center">
            <h6 className="section-title-lp bg-white text-center text-purple px-3 mb-5">
              Experience excellence in education
            </h6>
          </div>
          <div className="service-row">
            <div className="service-item text-center pt-3">
              <div className="p-4">
                <i className="fa fa-3x fa-globe text-purple mb-4"></i>
                <h5 className="mb-3">Variety of courses</h5>
                <p>
                  Our university offers a variety of courses to meet the needs
                  of every student. From Business to Biology, and from
                  Psychology to Politics, our university provides the right
                  courses to help students reach their educational goals.
                </p>
              </div>
            </div>
            <div className="service-item text-center pt-3">
              <div className="p-4">
                <i className="fa fa-3x fa-home text-purple mb-4"></i>
                <h5 className="mb-3">Campus Facilities</h5>
                <p>
                  Our university provides a wide range of facilities to ensure
                  that all students have the best possible educational
                  experience. We offer state-of-the-art classNamerooms, computer
                  labs, and libraries; recreational and athletic facilities; and
                  a variety of student services.
                </p>
              </div>
            </div>
            <div className="service-item text-center pt-3">
              <div className="p-4">
                <i className="fa fa-3x fa-book text-purple mb-4"></i>
                <h5 className="mb-3">Library of Knowledge</h5>
                <p>
                  The Library of Knowledge is a comprehensive collection of
                  resources available to students and faculty at our university.
                  It includes books, journals, magazines, and other materials
                  that can be used to further research, expand knowledge, and
                  enhance understanding.
                </p>
              </div>
            </div>
            <div className="service-item text-center pt-3">
              <div className="p-4">
                <i className="fa fa-3x fa-graduation-cap text-purple mb-4"></i>
                <h5 className="mb-3">Skilled Instructors</h5>
                <p>
                  Get ready to learn from the best! Our university provides
                  skilled instructors for your educational needs. Our university
                  is dedicated to providing you with the best educational
                  experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* EXCELLENCE End */}

      {/* alumni Start */}
      <section id="alumni">
        <div className="container py-5">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title-lp bg-white text-center text-purple px-3">
              Our Alumni
            </h6>
            <h1 className="mb-5">Working At</h1>
          </div>
          <div className="row g-4 alumni-carousel">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={20}
              slidesPerView={4}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 4,
                },
                1000: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 8,
                },
              }}
            >
              {alumniData.map((alumni, index) => (
                <SwiperSlide key={index}>
                  <div
                    className={`testimonial-item text-center mx-3 wow fadeInUp`}
                    data-wow-delay={`${0.1 + (index % 4) * 0.2}s`}
                  >
                    <div className="team-item">
                      <div className="overflow-hidden">
                        <img
                          className="img-fluid"
                          src={alumni}
                          loading="lazy"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
      {/* alumni End */}

      {/* Footer Start */}
      <section
        className="container-fluid bg-dark text-light footer pt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                &copy; 2025
                <a
                  className="border-bottom ms-1"
                  href="https://isbmuniversity.edu.in/"
                >
                  ISBM University
                </a>
                , All Right Reserved.
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer End */}

      {/* Back to Top */}
      <a
        href="#navbar_top"
        className="btn btn-lg btn-gradient btn-lg-square back-to-top"
      >
        <i className="fa fa-arrow-up" aria-hidden="true"></i>
      </a>
    </div>
  );
}

export default LP;